import { cn } from "@/lib/utils"

/**
 * Marcador de contenido que está llegando.
 *
 * Usa un barrido de brillo en vez de `animate-pulse`: el pulso de opacidad
 * lee como "algo está deshabilitado", mientras que el barrido direccional
 * lee como "esto se está cargando".
 */
function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      aria-hidden="true"
      className={cn("shimmer rounded-md bg-muted", className)}
      {...props}
    />
  )
}

export { Skeleton }
